angular.module('angus.controllers').directive('shipments', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'templates/tankMonitor/inventoryManagement/shipments/shipmentView.html'
    };
});
  